import React, { useEffect } from "react"
import { graphql } from "gatsby"
import AOS from "aos"

export const query = graphql`
  fragment ArticleContentQuoteFields on DatoCmsArticleBlockQuote {
    id
    model {
      apiKey
    }
    textNode {
      childMarkdownRemark {
        html
      }
    }
    author
    jobTitle
  }
`

import { ArticleContentQuoteFieldsFragment } from "../../../../graphql-types"

const ArticleBlockQuote: React.FC<ArticleContentQuoteFieldsFragment> = props => {
  useEffect(() => {
    AOS.init()
    AOS.refresh()
  })
  return (
    props.textNode && (
      <div className="c-article-block-quote">
        <blockquote
          data-aos="quote"
          className="c-article-block-quote__quote"
          dangerouslySetInnerHTML={{
            __html: props.textNode.childMarkdownRemark.html,
          }}
        />
        {props.author && (
          <div className="c-article-block-quote__byline">
            <span>{props.author}</span>
            {props.jobTitle && <> – {props.jobTitle}</>}
          </div>
        )}
      </div>
    )
  )
}

export default ArticleBlockQuote
